class ToggleCollections extends HTMLElement {
    constructor() {
      super();

      this.toggle_buttons = this.querySelectorAll('.toggle-collection__header');
      this.toggle_items = this.querySelectorAll('.toggle-collection__item');

      this.setupEvents();
    }
  
    setupEvents() {
        this.toggle_buttons.forEach((button) => {
            button.addEventListener('click', this.toggleCollection.bind(this));
        });
    }

    hideCollection() {
        this.toggle_items.forEach((item) => {
            item.classList.remove('actif');
        });
    }

    toggleCollection(event) {
        if (!(event.target.closest('.toggle-collection__item').classList.contains('actif'))) {
            this.hideCollection();
            event.target.closest('.toggle-collection__item').classList.add('actif');
        } else {
            this.hideCollection();
        }
    }
   
  }
  
  customElements.define('toggle-collection', ToggleCollections);
  